import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "company-management" };
const _hoisted_2 = { class: "card-header" };
const _hoisted_3 = { class: "content-preview" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
    key: 1,
    class: "empty-content"
};
const _hoisted_6 = {
    key: 0,
    class: "update-info"
};
const _hoisted_7 = { class: "update-time" };
const _hoisted_8 = { class: "editor-container" };
const _hoisted_9 = { class: "preview-section" };
const _hoisted_10 = { class: "preview-content" };
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = {
    key: 1,
    class: "empty-preview"
};
const _hoisted_13 = { class: "dialog-footer" };
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { Edit } from '@element-plus/icons-vue';
import { getCompanyProfile, updateCompanyProfile } from '@/api/content';
import { uploadImage } from '@/api/content';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import '@wangeditor/editor/dist/css/style.css';
import config from '@/config';
// 响应式数据
export default /*@__PURE__*/ _defineComponent({
    __name: 'Company',
    setup(__props) {
        const loading = ref(false);
        const dialogVisible = ref(false);
        const submitting = ref(false);
        const formRef = ref();
        // 公司简介数据
        const companyProfile = reactive({
            contentHtml: ''
        });
        // 表单数据
        const formData = reactive({
            contentHtml: ''
        });
        // 表单验证规则
        const formRules = {
            contentHtml: [
                { required: true, message: '请输入公司简介内容', trigger: 'blur' }
            ]
        };
        // 加载公司简介
        const loadCompanyProfile = async () => {
            try {
                loading.value = true;
                const response = await getCompanyProfile();
                Object.assign(companyProfile, response.data);
            }
            catch (err) {
                console.error('加载公司简介失败:', err);
                ElMessage.error('加载公司简介失败');
            }
            finally {
                loading.value = false;
            }
        };
        // 显示编辑对话框
        const showEditDialog = () => {
            formData.contentHtml = companyProfile.contentHtml;
            dialogVisible.value = true;
        };
        // 处理提交
        const handleSubmit = async () => {
            if (!formRef.value)
                return;
            const valid = await formRef.value.validate().catch(() => false);
            if (!valid)
                return;
            try {
                submitting.value = true;
                const response = await updateCompanyProfile(formData);
                Object.assign(companyProfile, response.data);
                ElMessage.success('保存成功');
                dialogVisible.value = false;
            }
            catch (err) {
                console.error('保存失败:', err);
                ElMessage.error('保存失败');
            }
            finally {
                submitting.value = false;
            }
        };
        // wangEditor 设置
        const editorRef = ref();
        const toolbarConfig = { excludeKeys: ['insertImage'] };
        const editorConfig = {
            MENU_CONF: {
                uploadImage: {
                    async customUpload(file, insertFn) {
                        const res = await uploadImage(file);
                        const url = res.data.url;
                        const abs = url.startsWith('http') ? url : `${config.staticBaseUrl}${url}`;
                        insertFn(abs);
                    }
                }
            }
        };
        const handleEditorCreated = (editor) => {
            editorRef.value = editor;
        };
        // 格式化日期时间
        const formatDateTime = (dateString) => {
            return new Date(dateString).toLocaleString('zh-CN');
        };
        // 初始化
        onMounted(() => {
            loadCompanyProfile();
        });
        return (_ctx, _cache) => {
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_empty = _resolveComponent("el-empty");
            const _component_el_card = _resolveComponent("el-card");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_dialog = _resolveComponent("el-dialog");
            const _directive_loading = _resolveDirective("loading");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "page-header" }, [
                    _createElementVNode("h2", null, "公司简介管理")
                ], -1)),
                _withDirectives((_openBlock(), _createBlock(_component_el_card, null, {
                    header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _cache[4] || (_cache[4] = _createElementVNode("span", null, "公司简介内容", -1)),
                            _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: showEditDialog
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Edit))
                                        ]),
                                        _: 1
                                    }),
                                    _cache[3] || (_cache[3] = _createTextVNode(" 编辑内容 ", -1))
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                            (companyProfile.contentHtml)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "html-content",
                                    innerHTML: companyProfile.contentHtml
                                }, null, 8, _hoisted_4))
                                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_el_empty, { description: "暂无公司简介内容" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_el_button, {
                                                type: "primary",
                                                onClick: showEditDialog
                                            }, {
                                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                        _createTextVNode(" 立即添加 ", -1)
                                                    ]))]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]))
                        ]),
                        (companyProfile.updatedAt)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("span", _hoisted_7, "最后更新时间：" + _toDisplayString(formatDateTime(companyProfile.updatedAt)), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })), [
                    [_directive_loading, loading.value]
                ]),
                _createVNode(_component_el_dialog, {
                    modelValue: dialogVisible.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((dialogVisible).value = $event)),
                    title: "编辑公司简介",
                    width: "80%",
                    "close-on-click-modal": false
                }, {
                    footer: _withCtx(() => [
                        _createElementVNode("span", _hoisted_13, [
                            _createVNode(_component_el_button, {
                                onClick: _cache[1] || (_cache[1] = ($event) => (dialogVisible.value = false))
                            }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                        _createTextVNode("取消", -1)
                                    ]))]),
                                _: 1
                            }),
                            _createVNode(_component_el_button, {
                                type: "primary",
                                loading: submitting.value,
                                onClick: handleSubmit
                            }, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                        _createTextVNode(" 保存 ", -1)
                                    ]))]),
                                _: 1
                            }, 8, ["loading"])
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_el_form, {
                            ref_key: "formRef",
                            ref: formRef,
                            model: formData,
                            rules: formRules,
                            "label-width": "100px"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                    label: "简介内容",
                                    prop: "contentHtml"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createVNode(_unref(Toolbar), {
                                                editor: editorRef.value,
                                                "default-config": toolbarConfig,
                                                mode: 'default'
                                            }, null, 8, ["editor"]),
                                            _createVNode(_unref(Editor), {
                                                modelValue: formData.contentHtml,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.contentHtml) = $event)),
                                                "default-config": editorConfig,
                                                mode: 'default',
                                                onOnCreated: handleEditorCreated
                                            }, null, 8, ["modelValue"])
                                        ])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["model"]),
                        _createElementVNode("div", _hoisted_9, [
                            _cache[6] || (_cache[6] = _createElementVNode("h3", null, "内容预览", -1)),
                            _createElementVNode("div", _hoisted_10, [
                                (formData.contentHtml)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "html-content",
                                        innerHTML: formData.contentHtml
                                    }, null, 8, _hoisted_11))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_12, " 输入内容后，这里会显示预览效果 "))
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
